<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "@/components/widgets/preloader";
    import { mapGetters,mapActions,mapState } from "vuex"
    import axios from 'axios';
    import moment from "moment";
    import { ModelListSelect } from "vue-search-select";
    import Swal from "sweetalert2";
    
    /**
     * Advanced table component
     */
    export default {
      page: {
        title: "Payments Report",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        PageHeader,
        Loader,
        ModelListSelect,
      },
      data() {
        return {
          total_amount: 0,
          total_paid: 0,
          filterPayments:{
            datefrom: moment(new Date()).format("YYYY-MM-DD"),
            dateto: moment(new Date()).format("YYYY-MM-DD"),
            customer: '',
          },
          currentdate: moment(new Date()).format("YYYY-MM-DD"),
          title: "Payments Report",
          items: [
            {
              text: "Home",
              href: "/",
            },
            {
              text: "Payments Report",
              active: true,
            },
          ],
          totalRows: 1,
    
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100, 200, 1000],
          filter: null,
          todoFilter: null,
          filterOn: [],
          todofilterOn: [],
          sortDesc: false,
          modal_id: "",
          amountError: "",
          fields: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "customer",
              sortable: true,
              label: 'CUSTOMER',
            },
            {
              key: "page",
              sortable: true,
              label: 'PAGE NO',
            },
            {
              key: "amount",
              sortable: true,
              label: 'AMOUNT',
            },
            {
              key: "date",
              sortable: true,
              label: 'DATE',
            },
            {
              key: "mode",
              sortable: true,
              label: 'PAYMENT MODE',
            },
            {
              key: "receipt",
              sortable: true,
              label: "RECEIPT_NO",
            },
            {
              key: "recordedby",
              sortable: true,
              label: "RECEIVED_BY",
            },
            {
              key: "actions",
              sortable: true,
              label: "ACTIONS",
            }
          ],
          fields1: [
            {
              key: "index",
              sortable: true,
              label: "S/N",
            },
            {
              key: "customer",
              sortable: true,
              label: 'CUSTOMER',
            },
            {
              key: "page",
              sortable: true,
              label: 'PAGE NO',
            },
            {
              key: "amount",
              sortable: true,
              label: 'AMOUNT',
            },
            {
              key: "date",
              sortable: true,
              label: 'DATE',
            },
            {
              key: "mode",
              sortable: true,
              label: 'PAYMENT MODE',
            },
            {
              key: "receipt",
              sortable: true,
              label: "RECEIPT_NO",
            },
            {
              key: "recordedby",
              sortable: true,
              label: "RECEIVED_BY",
            },
            {
              key: "branch",
              sortable: true,
              label: "BRANCH",
            },
            {
              key: "actions",
              sortable: true,
              label: "ACTIONS",
            }
          ],
          data:{
            paid:"",
            id:"",
          },
          editdata:{
            amount:""
          },
          deletedata:{
            id:"",
            amount:""
          }
        };
      },
      computed: {
             // MAP STATE
        ...mapState("notification", [
          "type",
          "message",
          "show",
          ]),
        ...mapGetters("sales", ["filterStatus","SalePayments","SaveStatus"]),
        ...mapGetters("customers", ["Customers"]),
        ...mapGetters("auth",["MyUserPerm","business","branch","Branches","branchid"]),
        ...mapGetters("setting", ["GeneralSettings"]),
        
    
        /**
         * Total no. of records
         */
    
        rows() {
          return this.SalePayments ? this.SalePayments.length : 1;
        },
    
        /**
         * Todo list of records
         */
      },
      mounted() {
        // Set the initial number of items
        this.totalRows = this.SalePayments ? this.SalePayments.length : 1;
      },  
      methods: {
        ...mapActions({
          FetchPayments: "sales/fetchPayments",
          FetchCustomers: "customers/fetchCustomers",
          FetchBranches: "auth/fetchBranches",
          FetchGeneralSettings: "setting/fetchGeneralSettings",
          EditPaid: "sales/EditPayment",
          DeletePaid: "sales/DeletePayment",
    
        }),
    
        // COMMA SEPERATORS
        thousandSeperator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
                .toString()
                .replace(/[^0-9.]+/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
    
        SalesPaymentsData() {
          this.FetchPayments(this.filterPayments);
        },
        /**
         * Search the table data with search input
         */
        onFiltered(filteredItems) {
          // Trigger pagination to update the number of buttons/pages due to filtering
          this.totalRows = filteredItems.length;
          this.currentPage = 1;
        },
        Excel_export() {
          axios
            .post("export_payments", this.filterPayments,{
              responseType: "arraybuffer",
            })
            .then((response) => {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement("a");
              fileLink.href = fileURL;
              fileLink.setAttribute("download", "payments_report.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();
              this.spinner = false;
            })
            .catch(() => {
              // this.spinner = false;
              // this.$toast.add({
              //   severity: "error",
              //   summary: "Something wrong",
              //   detail: "Sales Report Download failed",
              //   life: 6000,
              // });
            });
        },
        editAmt(modalId){
            this.modal_id = modalId;
            if(this.data.paid==""){
                this.amountError = "Amount Paid is required";
                return
            }
            else{
                this.amountError = "";
            }
            this.EditPaid(this.data).then(() => {
                this.FetchPayments(this.filterPayments);
            });
        },
        deletePayment(modalId){
            this.modal_id = modalId;
            this.DeletePaid(this.deletedata.id).then(() => {
                this.FetchPayments(this.filterPayments);
            });
        },
        addCommas() {
            this.data.paid = this.thousandSeperator(this.data.paid);
        },
        resetError(){
            this.amountError = "";
        },
        closeModal(modalId) {
            this.resetError();
            this.$nextTick(() => {
                this.$bvModal.hide(modalId);
            });
        },
        showEditModal(data){
            this.editdata.amount = this.thousandSeperator(data.amount);
            this.data.paid = this.thousandSeperator(data.amount);
            this.data.id = data.id;
        },
        showDeleteModal(data){
            this.deletedata.id = data.id;
            this.deletedata.amount = this.thousandSeperator(data.amount);
        },
        resetDelete(){
            this.deletedata.id = "";
            this.deletedata.amount = "";
        },
      },
      updated() {
        let total_amount = 0;
          // let total_paid = 0;
          if(this.SalePayments){
            this.SalePayments.forEach((item)=>{
              total_amount = total_amount+parseInt(item.amount);
            });
            this.total_amount = parseInt(total_amount);
          }
      },
      watch: {
        SalePayments(newValue){
          if(newValue == true){
            this.SalesPaymentsData();
          }
        },

        show(newValue) {
          if (newValue == true) {
            if (this.type == "success") {
                this.closeModal(this.modal_id);
              Swal.fire("Success!", this.message.msg, "success");
            } else {
              Swal.fire("Error!", this.message.msg, "error");
            }
          }
        },
      },
      created() {
        this.FetchPayments(this.filterPayments);
        this.FetchCustomers();
        this.SalesPaymentsData();
        this.FetchBranches();
        this.FetchGeneralSettings();
      },
    };
    </script>
    
    <template>
      <Layout>
        <div class="row py-3 text-center">
          <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
        </div>
        <PageHeader :title="title" :items="items" />
    
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-9">
                    <h3 class="card-title mb-2 text-center">Payments Report from {{filterPayments.datefrom}} to {{filterPayments.dateto}}</h3>
                  </div>
                </div>            
                <div class="row">
                  <div class="col-md-3 mt-4">
                    <b-button variant="info" @click="Excel_export()"
                      ><i class="fa fa-download"></i>Export</b-button
                    >
                  </div>
                  <div class="col-md-2 form-group mb-2">
                    <label>FROM</label>
                    <input
                      type="date"
                      v-model="filterPayments.datefrom"
                      class="form-control"
                      @change="SalesPaymentsData()"
                    />
                  </div>
                  <div class="col-md-2 form-group">
                    <label>TO</label>
                    <input
                      v-model="filterPayments.dateto"
                      type="date"
                      class="form-control"
                      @change="SalesPaymentsData()"
                    />
                  </div>
                  <div class="col-md-3 form-group">
                    <label>CUSTOMERS</label>
                    
                    <model-list-select
                      :list="Customers ? Customers : []"
                      v-model="filterPayments.customer"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Customer"
                      @input="SalesPaymentsData()"
                    >
                    </model-list-select>
                  </div>
                  <div class="col-md-2 mt-4">
                  <button class="btn btn-primary" type="button" @click="SalesPaymentsData()">
                    <span class="fa fa-filter"></span> Filter
                    <b-spinner
                      v-show="filterStatus"
                      variant="light"
                      small
                      role="status"
                    ></b-spinner>
                  </button>
                </div>
                </div>
                <div class="row mt-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                    >
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                      class="datatables"
                      :items="SalePayments?SalePayments:[]"
                      :fields="branchid==0?fields1:fields"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(amount)="data">
                      {{thousandSeperator(data.item.amount) }}
                    </template>
                    <template #cell(actions)="data">
                        <div>
                        <b-dropdown text="More Actions..." size="sm" class="btn-primary" v-if="MyUserPerm.modify_sales == 1">
                            <b-dropdown-item 
                                v-if="MyUserPerm.delete_sales == 1"
                                v-b-modal.delete-payment-modal
                                @click="showDeleteModal(data.item)">
                                <i class="fa fa-trash text-danger"></i> <span class="text-danger">Delete</span> 
                            </b-dropdown-item>
                            <b-dropdown-item
                            v-if="MyUserPerm.edit_sales == 1"
                            v-b-modal.edit-payment-modal
                            @click="showEditModal(data.item)"
                            ><i class="fa fa-edit text-primary"></i> <span class="text-primary">Edit</span>
                            </b-dropdown-item> 
                        </b-dropdown>
                        </div>
                    </template>           
                  </b-table>
                  <div class="row">
                      <div class="col-md-4"></div>
                      <div class="col-md-4">
                        <h5>Total Amount: <span class="text-danger">{{thousandSeperator(total_amount)}}</span></h5>
                      </div>
                    </div>
                    <!-- modal mark as expired starts -->
                        <b-modal id="edit-payment-modal" hide-footer>
                        <template #modal-title>
                            <h4 class="text-warning">Edit Amount Paid For a Sale of {{ thousandSeperator(editdata.amount) }}</h4></template
                        >
                            <label>Amount Paid</label>
                            <div class="input-group">
                            <input
                                type="text"
                                class="form-control"
                                v-model="data.paid"
                                placeholder="Enter actual amount"
                                @input="resetError(),addCommas()"
                            />
                            </div>
                            <div class="text-danger" v-if="amountError">
                            <em>{{ amountError }}</em>
                            </div>
                        <div class="modal-footer">
                            <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            @click="closeModal('edit-payment-modal')"
                            >
                            <i class="fa fa-times"></i> Close
                            </button>
                            <button type="button" class="btn btn-warning" @click="editAmt('edit-payment-modal')">
                            <i class="fa fa-minus"></i> Confirm
                            <b-spinner
                                v-if="SaveStatus"
                                variant="light"
                                small
                                label="Submiting"
                            ></b-spinner>
                            </button>
                        </div>
                        </b-modal>
                        <!-- modal ends -->
                    <!--Payment delete modal starts -->
                    <b-modal
                      header-bg-variant="danger"
                      header-text-variant="light"
                      body-text-variant="danger"
                      footer-bg-variant="danger"
                      footer-text-variant="danger"
                      id="delete-payment-modal"
                      hide-footer
                      @hidden="resetDelete"
                    >
                      <template #modal-title> Delete Payment of amount {{ thousandSeperator(deletedata.amount) }}</template>
                      <div class="form-group mb-2">
                        <div class="input-group">
                          <h5>
                            Do you want to delete this Payment? Click Proceed Button to delete.
                          </h5>
                        </div>
                      </div>
                      <div class="modal-footer">
                          <button
                          type="button"
                          class="btn btn-secondary"
                          data-dismiss="modal"
                          @click="closeModal('delete-payment-modal')"
                          >
                          <i class="fa fa-times"></i> Close
                          </button>
                          <button type="button" class="btn btn-danger" @click="deletePayment('delete-payment-modal')">
                          <i class="fa fa-minus"></i> Proceed
                          <b-spinner
                              v-if="SaveStatus"
                              variant="light"
                              small
                              label="Submiting"
                          ></b-spinner>
                          </button>
                      </div>
                    </b-modal>
                    <!-- modal ends -->
                </div>
                <Loader  v-if="!SalePayments"/>
                <div class="row">
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </template>
    
    <style>
    .btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
    </style>
    